// routers
import router from './portfolio.route'

// runs
import run from './portfolio.run'

// services
import PortfolioSrv from './portfolioSrv'
import PortfolioModalSrv from './portfolioModalSrv'
import GlobalSrv from '../../../globalSrv'

// controllers
import myPortfolioCtrl from './myPortfolio/myPortfolioCtrl'
import sharedPortfolioCtrl from './sharedPortfolio/sharedPortfolioCtrl'
import otherPortfolioCtrl from './otherPortfolio/otherPortfolioCtrl'
import powerbiPortfolioCtrl from './portfolioPowerbi/powerbiPortfolioCtrl'
import evaluationPortfolioCtrl from './evaluationPortfolio/evaluationPortfolioCtrl'
import portfolioParametrizationCtrl from './parametrization/portfolioParametrizationCtrl'

//modals controllers
import addUserCommentCtrl from './myPortfolio/modals/addUserCommentCtrl'
import addReflectionCommentCtrl from './myPortfolio/modals/addReflectionCommentCtrl'
import addNewRegistryCtrl from './myPortfolio/modals/addNewRegistryCtrl'
import evidenceLinksCtrl from './myPortfolio/modals/evidenceLinksCtrl'
import disableEvidenceCtrl from './myPortfolio/modals/disableEvidenceCtrl'
import editEvidenceCtrl from './myPortfolio/modals/editEvidenceCtrl'
import editStatementCtrl from './myPortfolio/modals/editStatementCtrl'
import historyStatementCtrl from './myPortfolio/modals/historyStatementCtrl'
import commentDetailsCtrl from './myPortfolio/modals/commentDetailsCtrl'
import editReflectionCtrl from './myPortfolio/modals/editReflectionCtrl'
import deleteReflectionCtrl from './myPortfolio/modals/deleteReflectionCtrl'
import confirmDialogCtrl from './sharedPortfolio/modals/confirmDialogCtrl'
import guidelineDetailsCtrl from './parametrization/modals/guidelineDetailsCtrl'

// config file
import GlobalConfig from '../../../globals/globalConfig.json'

export default angular.module('app.portfolio', [ PortfolioSrv, PortfolioModalSrv, GlobalSrv ])
	.config(router)
	.run(run)
	.controller('MyPortfolioCtrl', myPortfolioCtrl)
	.controller('SharedPortfolioCtrl', sharedPortfolioCtrl)
	.controller('OtherPortfolioCtrl', otherPortfolioCtrl)
	.controller('powerbiPortfolioCtrl', powerbiPortfolioCtrl)
	.controller('PortfolioParametrizationCtrl', portfolioParametrizationCtrl)

//modals portfolio
	.controller('AddUserCommentCtrl', addUserCommentCtrl)
	.controller('AddReflectionCommentCtrl', addReflectionCommentCtrl)
	.controller('AddNewRegistryCtrl', addNewRegistryCtrl)
	.controller('EvidenceLinksCtrl', evidenceLinksCtrl)
	.controller('DisableEvidenceCtrl', disableEvidenceCtrl)
	.controller('EditEvidenceCtrl', editEvidenceCtrl)
	.controller('EditStatementCtrl', editStatementCtrl)
	.controller('HistoryStatementCtrl', historyStatementCtrl)
	.controller('EvaluationPortfolioCtrl', evaluationPortfolioCtrl)
	.controller('CommentDetailsCtrl', commentDetailsCtrl)
	.controller('EditReflectionCtrl', editReflectionCtrl)
	.controller('DeleteReflectionCtrl', deleteReflectionCtrl)
	.controller('ConfirmDialogCtrl', confirmDialogCtrl)
	.controller('GuidelineDetailsCtrl', guidelineDetailsCtrl)

//nav bar
	.constant('portfolio', [ {
		title   : 'Portafolio',
		icon    : 'mdi-file-folder-shared',
		moduleId: GlobalConfig.menuModulesId.Portfolio,
		subMenu : [
			{
				title       : 'Mi portafolio',
				url         : 'portfolio.myPortfolio',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.generalConsultant ],
			},
			{
				title       : 'Otros portafolios',
				url         : 'portfolio.otherPortfolio',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.generalConsultant ],
			},
			{
				title       : 'Reporte portafolio de Profesores',
				url         : 'portfolio.powerbi',
				rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
			},
			{
				title       : 'Compartir mi portafolio',
				url         : 'portfolio.sharedPortfolio',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher ],
			},
			{
				title       : 'Evaluar portafolios',
				url         : 'portfolio.listEvaluationPortfolio',
				rolesAllowed: [ GlobalConfig.userRolesIds.comitePortfolio, GlobalConfig.userRolesIds.committee ],
			},
			{
				title       : 'Parametrización',
				url         : 'portfolio.parametrization',
				rolesAllowed: [ GlobalConfig.userRolesIds.adminPortfolio, GlobalConfig.userRolesIds.adminPortfolio ],
			},
		],
	} ])
	.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/index.js